import type { Story } from '@/mocks/featuredStories';

interface Props {
  lead: Story;
  quick: Story[];
  onOpen: (s: Story) => void;
}

export default function HeroToday({ lead, quick, onOpen }: Props) {
  return (
    <section id="today" className="mx-auto w-full max-w-6xl px-4 pt-10 md:px-6 md:pt-14">
      <div className="flex items-end justify-between gap-4 border-b-2 border-foreground-950 pb-3">
        <div className="flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line" />
          </span>
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">今日重磅</h2>
            <p className="text-xs text-foreground-500">TODAY'S TOP STORY · 不容错过</p>
          </div>
        </div>
        <a
          href="#feed"
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-800 sm:flex"
        >
          去全量吃瓜流 <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="mt-5 grid gap-5 lg:grid-cols-5">
        {/* 头版大稿 */}
        <button
          type="button"
          onClick={() => onOpen(lead)}
          className="group relative block w-full overflow-hidden rounded-2xl text-left lg:col-span-3"
        >
          <div className="relative aspect-[16/10] w-full overflow-hidden">
            <img
              src={lead.cover}
              alt={lead.title}
              className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent" />
            <span className="absolute left-4 top-4 flex items-center gap-1 rounded bg-primary-500 px-2.5 py-1 text-xs font-bold tracking-widest text-background-50">
              <i className="ri-star-fill" /> 头条
            </span>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <p className="mb-2 flex items-center gap-2 text-xs text-background-100/90">
                <span className="rounded bg-accent-500 px-1.5 py-0.5 text-foreground-950">{lead.category}</span>
                {lead.source} · {lead.timeLabel}
              </p>
              <h3 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl lg:text-[26px]">
                {lead.title}
              </h3>
              <p className="mt-2 hidden text-sm leading-relaxed text-background-200 md:line-clamp-2">
                {lead.dek}
              </p>
              <p className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-300">
                <i className="ri-book-open-line" /> 点开阅读全文
                <i className="ri-arrow-right-line transition group-hover:translate-x-1" />
              </p>
            </div>
          </div>
        </button>

        {/* 右侧速览 */}
        <div className="flex flex-col gap-3 lg:col-span-2">
          <p className="flex items-center gap-2 text-sm font-medium text-foreground-700">
            <i className="ri-time-line text-primary-500" /> 今日三连看 · 条条值得
          </p>
          {quick.map((s) => (
            <button
              key={s.id}
              type="button"
              onClick={() => onOpen(s)}
              className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-3.5 text-left transition hover:border-primary-300 hover:bg-primary-50/60"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50">
                <i className="ri-quill-pen-line" />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
                  {s.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded bg-accent-100 px-1.5 text-accent-800">{s.category}</span>
                  <span className="truncate">{s.heat} 热度</span>
                </span>
              </span>
              <i className="ml-auto shrink-0 text-foreground-300 transition group-hover:text-primary-500 ri-arrow-right-s-line" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}